import { comment } from "stylis"

// issueReport.js
const issueReport = {
    create: () => 'create/offer',
    getById: (id) => `getOfferById/${id}`,
    updateById: (id) => `/update/issueReport/${id}`,
    comment: (id) => `create/issueReport/${id}`,
    getIssueDetailID: (id) => `getIssueReportById/${id}`,
}
export default issueReport
